var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.view,{tag:"component",attrs:{"profile":_vm.profile},on:{"update:profile":_vm.updateProfile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }